import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ESpinner from "components/others/Spinner";
import * as apiObject from "api/apiObjects";
import { useObjectCard } from "../context/ObjectCardProvider";
import ExpendTeamInfo from "./ExpendTeamInfo";

const OffExpendTeamInfo = ({show,setShow}) => {

    const { t } = useTranslation(['Objects'])
    const { objectId } = useObjectCard();
    const [ expendTeam, setEpendTeam ] = useState(null);

    const fetchExpendTeam = async () =>{ 
        const resExpend = await apiObject.getObjectExpendTeam(objectId, show);
        setEpendTeam(resExpend);
    }

    const handleHide = () =>{
        setShow(false);
        setTimeout(() => {
            setEpendTeam(null);
        }, 300);
    }
 
    useEffect(()=>{
        if (show) fetchExpendTeam()
            else handleHide();
    },[show])

    return (
        <Offcanvas 
            show={show!==false} 
            onHide={handleHide}
            placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleOperInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="px-0 position-relative">
                {expendTeam
                    ? (<ExpendTeamInfo expendTeam={expendTeam}/>)
                    : (<ESpinner/>)}
            </Offcanvas.Body>
        </Offcanvas>
         
    )
}

export default OffExpendTeamInfo;